import actionsSchedule from "./actions";

export default {
  namespaced: true,
  actions: actionsSchedule,
};
